import { Box, Button, Container, Grid, Paper, Typography, Link } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ImageAnalyzer from "../../components/ImageAnalyzer";
import ImageAnalysisResult from "../../services/ImageAnalysis/ImageAnalysisResult";
import FileData from "../../components/Image/FileData";
import ImageList from "../../components/Image/ImageList";
import i18n from "../../i18n";
import DashboardCard from "../../components/DashboardCard";
import ResultDetail from "../../services/ImageAnalysis/ResultDetail";
import parse from "html-react-parser";
import DialogConditions from "./DialogConditions";
import MeOrganizationResponse from "../../services/Authentification/MeOrganizationResponse";

interface Props {
  organization: MeOrganizationResponse | undefined;
  setConsultCondition: (consultConditionId: string, documentIds: string[]) => Promise<void>;
  cancel: () => void;
}
export default function IdentifyCondition(props: Props) {
  const { t } = useTranslation();

  const [result, setResult] = useState<ImageAnalysisResult | undefined>(undefined);
  const [files, setFiles] = useState<Array<FileData>>([]);
  const [open, setOpen] = useState(false);

  const openChanged = (state: boolean) => {
    setOpen(state);
  };

  const onAnalysisDone = (result: ImageAnalysisResult, files: Array<FileData>) => {
    setFiles(files);
    setResult(result);
  };

  const restart = () => {
    setFiles([]);
    setResult(undefined);
  };

  return (
    <Container sx={{ marginTop: 5 }}>
      <Typography variant="h1" gutterBottom>
        {t("identify-condition.title")}
      </Typography>

      {props.organization?.organization.healthProfessionnal && (
        <Box mt={3} mb={3}>
          {parse(t("create-consult.identify-description1a-hp"))}
          <Link
            href="#"
            color="inherit"
            onClick={() => {
              setOpen(true);
            }}
            marginLeft={0.5}
            marginRight={0.5}
          >
            {parse(t("create-consult.identify-description1b-hp"))}
          </Link>
          {parse(t("create-consult.identify-description1c-hp"))}
        </Box>
      )}

      <Grid container spacing={2}>
        <Grid item lg={12}>
          {!result && (
            <ImageAnalyzer minImages={props.organization?.organization.healthProfessionnal ? 1 : 2} onAnalysisDone={onAnalysisDone} onCancel={props.cancel} />
          )}

          {result && (
            <Grid container>
              <Grid item lg={12}>
                {files.length > 0 && <ImageList files={files} />}

                {result.resultDetails.length <= 0 && <Typography mt={1}>{t("identify-condition.analysis-result-nodisease")}</Typography>}
                {result.resultDetails.length > 0 && (
                  <>
                    <Typography mt={1}>{t("identify-condition.analysis-result-msg")}</Typography>
                    <ul>
                      {result.resultDetails
                        .filter((result) => result.condition)
                        .map((detail, index) => {
                          return <li key={index}>{detail.label[i18n.language]}</li>;
                        })}
                    </ul>

                    <Button variant="outlined" onClick={restart}>
                      {t("identify-condition.restart")}
                    </Button>
                  </>
                )}

                <Typography mt={4} mb={2}>
                  {t("identify-condition.analysis-result-advices")}
                </Typography>
                <Grid container spacing={3}>
                  {result.resultDetails
                    .filter((result) => result.consult)
                    .map((resultDetail: ResultDetail) => {
                      const ct = resultDetail.consult;
                      const label = ct?.label[i18n.language] ?? "";
                      const description = ct?.description[i18n.language] ?? "";

                      if (ct?.id) {
                        return (
                          <Grid key={ct?.id} item xs={12} md={6} lg={4}>
                            <DashboardCard title={label}>
                              <Box mb={3} minHeight={80}>
                                {description}
                              </Box>

                              <Button onClick={() => props.setConsultCondition(ct.id, result.documentIds)}>{t("create-consult.start-consult")}</Button>
                            </DashboardCard>
                          </Grid>
                        );
                      } else return <></>;
                    })}
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      <DialogConditions open={open} onChanged={openChanged} />
    </Container>
  );
}
